import { render, staticRenderFns } from "./DoriPerformanceDashboard.vue?vue&type=template&id=3bfd6987&scoped=true&"
import script from "./DoriPerformanceDashboard.vue?vue&type=script&lang=ts&"
export * from "./DoriPerformanceDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd6987",
  null
  
)

export default component.exports